/**
 * Audit-Trail Query-Hook (Spec 528, Phase 6).
 *
 * Duenner React-Query-Wrapper um {@link listAuditEvents}. Die Query laeuft nur,
 * wenn die gewaehlte Dimension vollstaendig ist ({@link isAuditQueryComplete}) —
 * so gibt es keinen 400-Roundtrip bei halb-ausgefuellten Filtern.
 */

import { useQuery } from '@tanstack/react-query';
import { listAuditEvents, isAuditQueryComplete } from '@/lib/api/audit';
import type { AuditQueryParams } from '@/types/audit';

export const auditEventKeys = {
  all: ['audit-events'] as const,
  list: (query: AuditQueryParams) => [...auditEventKeys.all, 'list', query] as const,
};

export function useAuditEvents(query: AuditQueryParams) {
  return useQuery({
    queryKey: auditEventKeys.list(query),
    queryFn: () => listAuditEvents(query),
    enabled: isAuditQueryComplete(query),
    staleTime: 30_000,
  });
}
